module.exports = __webpack_public_path__ + "img/audio-mark13.b24f79fb.png";